import React, { useState } from "react";

const VOWELS = ["A", "E", "I", "O", "U"];
const CONSONANTS = "BCDFGHJKLMNPQRSTVWXYZ".split("");

const generateLetterPool = (length = 12) => {
  const letters: string[] = [];

  // Ensure at least 3 vowels
  for (let i = 0; i < 3; i++) {
    letters.push(
      VOWELS[Math.floor(Math.random() * VOWELS.length)]
    );
  }

  // Fill remaining with consonants
  while (letters.length < length) {
    letters.push(
      CONSONANTS[Math.floor(Math.random() * CONSONANTS.length)]
    );
  }

  return letters.sort(() => Math.random() - 0.5);
};

const WordBuilder = () => {
  const [words, setWords] = useState<string[]>([]);
  const [input, setInput] = useState("");
  const [message, setMessage] = useState("");
  const [letterPool, setLetterPool] = useState<string[]>(
    generateLetterPool()
  );

  const isValidWord = (word: string) => {
    const upper = word.toUpperCase();

    // Only letters allowed
    if (!/^[A-Z]+$/.test(upper)) return false;

    // Must use available letters
    const tempPool = [...letterPool];
    for (let char of upper) {
      const index = tempPool.indexOf(char);
      if (index === -1) return false;
      tempPool.splice(index, 1);
    }

    return true;
  };

  const handleSubmit = () => {
    const trimmed = input.trim().toUpperCase();

    if (trimmed.length < 3) {
      setMessage("Use at least 3 letters");
      return;
    }

    if (words.includes(trimmed)) {
      setMessage("Already added 🌿");
      return;
    }

    if (!isValidWord(trimmed)) {
      setMessage("Use only available letters");
      return;
    }

    setWords((prev) => [...prev, trimmed]);
    setInput("");
    setMessage("Nice one ✨");
  };

  return (
    <div className="flex flex-col items-center">

      {/* Letter Pool */}
      <div className="flex flex-wrap justify-center gap-2 mb-6">
        {letterPool.map((letter, index) => (
          <div
            key={index}
            className="w-10 h-10 flex items-center justify-center
                       bg-orange-400 text-white rounded-lg font-semibold"
          >
            {letter}
          </div>
        ))}
      </div>

      {/* Input */}
      <div className="flex w-full max-w-md gap-2">
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Form a positive word"
          className="flex-1 border border-orange-200 focus:border-orange-500
                     outline-none rounded-lg p-3"
          onKeyDown={(e) => {
            if (e.key === "Enter") handleSubmit();
          }}
        />
        <button
          onClick={handleSubmit}
          className="px-4 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition"
        >
          Add
        </button>
      </div>

      {/* Feedback */}
      {message && (
        <p className="mt-3 text-sm text-gray-600">{message}</p>
      )}

      {/* Word Display */}
      <div className="flex flex-wrap gap-2 mt-6 justify-center">
        {words.map((word, index) => (
          <div
            key={index}
            className="px-4 py-2 bg-orange-100 text-orange-700 rounded-full text-sm"
          >
            {word}
          </div>
        ))}
      </div>

      {/* Completion */}
      {words.length >= 5 && (
        <p className="mt-6 text-green-600 font-medium">
          Beautiful word garden
        </p>
      )}
      <button
        onClick={() => {
          setLetterPool(generateLetterPool());
          setWords([]);
          setMessage("");
        }}
        className="mt-6 px-4 py-2 bg-orange-100 text-orange-700 rounded-lg hover:bg-orange-200 transition"
      >
        New Letters
      </button>
    </div>
  );
};

export default WordBuilder;